import { Routes } from '@angular/router';
import { authGuard, LoginGuard } from './shared/auth-helpers/auth.guard';
import { Role } from './shared/models/role';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
        title: 'Root Redirect',
    },
    {
        path: 'login',
        loadComponent: () =>
            import('./common/pages/login-page/login-page.component').then(
                (mod) => mod.LoginPageComponent,
            ),
        canActivate: [LoginGuard(false)],
        title: 'Login',
    },
    {
        path: 'uaepass-check',
        loadComponent: () =>
            import('./common/pages/uaepass-check/uaepass-check.component').then(
                (mod) => mod.UaepassCheckComponent,
            ),
        canActivate: [LoginGuard(false)],
        title: 'Login',
    },
    {
        path: 'register',
        loadComponent: () =>
            import('./common/pages/register/register.component').then(
                (mod) => mod.RegisterComponent,
            ),
        canActivate: [LoginGuard(false)],
        title: 'Register',
    },
    {
        path: 'password_reset',
        loadComponent: () =>
            import(
                './common/pages/password-reset/password-reset.component'
            ).then((mod) => mod.PasswordResetComponent),
        title: 'Reset Password',
        canActivate: [LoginGuard(false)],
    },
    {
        path: 'home',
        loadComponent: () =>
            import('./home/home.component').then((mod) => mod.HomeComponent),
        canMatch: [authGuard()],
        title: 'Global Star Rating',
        children: [
            {
                path: 'dashboard',
                canMatch: [
                    authGuard([
                        Role.Admin,
                        Role.TechnicalReviewer,
                        Role.EntityAdmin,
                        Role.Entity,
                        Role.Assessor,
                        Role.LeadAssessor,
                    ]),
                ],
                loadComponent: () =>
                    import('./common/pages/dashboard/dashboard.component').then(
                        (mod) => mod.DashboardComponent,
                    ),
                title: 'Dashboard',
            },
            {
                path: 'result-dashboard',
                canMatch: [
                    authGuard([
                        Role.Admin,
                        Role.TechnicalReviewer,
                        Role.EntityAdmin,
                        Role.Entity,
                        Role.Assessor,
                        Role.LeadAssessor,
                    ]),
                ],
                loadComponent: () =>
                    import(
                        './common/pages/result-dashboard/result-dashboard.component'
                    ).then((mod) => mod.ResultDashboardComponent),
                title: 'Results',
            },
            {
                path: 'assessors',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import(
                        './common/pages/assessors-list/assessors-list.component'
                    ).then((mod) => mod.AssessorsListComponent),
                title: 'Assessors',
            },
            {
                path: 'users',
                canMatch: [
                    authGuard([
                        Role.Admin,
                        Role.TechnicalReviewer,
                        Role.EntityAdmin,
                    ]),
                ],
                loadComponent: () =>
                    import(
                        './common/pages/users-list/users-list.component'
                    ).then((mod) => mod.UsersListComponent),
                title: 'Users',
            },
            {
                path: 'cycles',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import(
                        './common/pages/cycles-list/cycles-list.component'
                    ).then((mod) => mod.CyclesListComponent),
                title: 'Cycles',
            },
            {
                path: 'assessments',
                canMatch: [
                    authGuard([
                        Role.Admin,
                        Role.TechnicalReviewer,
                        Role.EntityAdmin,
                        Role.Entity,
                        Role.Assessor,
                        Role.LeadAssessor,
                    ]),
                ],
                loadComponent: () =>
                    import(
                        './common/pages/assessments-list/assessments-list.component'
                    ).then((mod) => mod.AssessmentsListComponent),
                title: 'Assessments',
            },
            {
                path: 'assessments/answers/:id/:assessorOwner',
                canMatch: [
                    authGuard([
                        Role.Admin,
                        Role.TechnicalReviewer,
                        Role.EntityAdmin,
                        Role.Entity,
                        Role.Assessor,
                        Role.LeadAssessor,
                    ]),
                ],
                loadComponent: () =>
                    import(
                        './common/pages/assessment-answers/assessment-answers.component'
                    ).then((mod) => mod.AssessmentAnswersComponent),
                title: 'Manage assessment Answers',
            },

            {
                path: 'upload-document',
                canMatch: [
                    authGuard([
                        Role.Admin,
                        Role.TechnicalReviewer,
                        Role.EntityAdmin,
                        Role.Entity,
                        Role.Assessor,
                        Role.LeadAssessor,
                    ]),
                ],
                loadComponent: () =>
                    import(
                        './common/pages/upload-documents-list/upload-documents-list.component'
                    ).then((mod) => mod.UploadDocumentsListComponent),
                title: 'Documents',
            },
            {
                path: 'upload-document/answers/:id',
                canMatch: [authGuard([Role.EntityAdmin, Role.Entity])],
                loadComponent: () =>
                    import(
                        './common/pages/documents-answers/documents-answers.component'
                    ).then((mod) => mod.DocumentsAnswersComponent),
                title: 'Manage Uploaded documnts Answers',
            },
            {
                path: 'upload-document/answers-review/:id',
                canMatch: [
                    authGuard([
                        Role.Admin,
                        Role.TechnicalReviewer,
                        Role.Assessor,
                        Role.LeadAssessor,
                    ]),
                ],
                loadComponent: () =>
                    import(
                        './common/pages/document-answers-review/document-answers-review.component'
                    ).then((mod) => mod.DocumentAnswersReviewComponent),
                title: 'Review Uploaded documnts Answers',
            },
            {
                path: 'upload-document/additional-documents/:id',
                canMatch: [
                    authGuard([
                        Role.Admin,
                        Role.TechnicalReviewer,
                        Role.EntityAdmin,
                        Role.Entity,
                        Role.Assessor,
                        Role.LeadAssessor,
                    ]),
                ],
                loadComponent: () =>
                    import(
                        './common/pages/additional-documents/additional-documents.component'
                    ).then((mod) => mod.AdditionalDocumentsComponent),
                title: 'Manage Additional Documents',
            },
            {
                path: 'assessors/assessor/:id',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import('./common/pages/assessor/assessor.component').then(
                        (mod) => mod.AssessorComponent,
                    ),
                title: 'Assessor',
            },
            {
                path: 'users/user',
                canMatch: [
                    authGuard([
                        Role.Admin,
                        Role.TechnicalReviewer,
                        Role.EntityAdmin,
                    ]),
                ],
                loadComponent: () =>
                    import('./common/pages/user/user.component').then(
                        (mod) => mod.UserComponent,
                    ),
                title: 'User',
            },
            {
                path: 'users/user/:id',
                canMatch: [
                    authGuard([
                        Role.Admin,
                        Role.TechnicalReviewer,
                        Role.EntityAdmin,
                    ]),
                ],
                loadComponent: () =>
                    import('./common/pages/user/user.component').then(
                        (mod) => mod.UserComponent,
                    ),
                title: 'User',
            },
            {
                path: 'cycles/cycle',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import('./common/pages/cycle/cycle.component').then(
                        (mod) => mod.CycleComponent,
                    ),
                title: 'Cycle',
            },
            {
                path: 'cycles/cycle/:id/:action',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import('./common/pages/cycle/cycle.component').then(
                        (mod) => mod.CycleComponent,
                    ),
                title: 'Cycle',
            },
            {
                path: 'cycles/deadlines/:id/:channelType',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import(
                        './common/pages/cycle-detail/cycle-detail.component'
                    ).then((mod) => mod.CycleDetailComponent),
                title: 'Manage',
            },
            {
                path: 'cycles/manage/:id',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import(
                        './common/pages/cycle-manage/cycle-manage.component'
                    ).then((mod) => mod.CycleManageComponent),
                title: 'Manage',
            },
            {
                path: 'cycles/assessment/:id/:channelType',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import(
                        './common/pages/assessment/assessment.component'
                    ).then((mod) => mod.AssessmentComponent),
                title: 'Manage Assessment',
            },
            {
                path: 'cycles/pillars/:id/:channelType',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import(
                        './common/pages/pillar-manage/pillar-manage.component'
                    ).then((mod) => mod.PillarManageComponent),
                title: 'Manage Pillars',
            },
            {
                path: 'cycles/documents/:id/:channelType',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import('./common/pages/documents/documents.component').then(
                        (mod) => mod.DocumentsComponent,
                    ),
                title: 'Manage Uploaded documnts',
            },

            {
                path: 'cycles/assign-assessors/:id/:channelType',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import(
                        './common/pages/assign-assessor/assign-assessor.component'
                    ).then((mod) => mod.AssignAssessorComponent),
                title: 'Assign Assessors',
            },

            {
                path: 'cycles/cycle-config/:id',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import(
                        './common/pages/cycle-config/cycle-config.component'
                    ).then((mod) => mod.CycleConfigComponent),
                title: 'Cycle Configration',
            },

            {
                path: 'cycles/external-sources-score/:cycleId/:channelType',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import(
                        './common/pages/external-sources-score/external-sources-score.component'
                    ).then((mod) => mod.ExternalSourcesScoreComponent),
                title: 'External Sources Score',
            },
            {
                path: 'cycles/questions-score/:id/:channelType',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import(
                        './common/pages/assessment-questions-score/assessment-questions-score.component'
                    ).then((mod) => mod.AssessmentQuestionsScoreComponent),
                title: 'Questions score',
            },

            {
                path: 'cycles/cycle-calculation/:id',
                canMatch: [authGuard([Role.Admin, Role.TechnicalReviewer])],
                loadComponent: () =>
                    import(
                        './common/pages/cycle-calculation/cycle-calculation.component'
                    ).then((mod) => mod.CycleCalculationComponent),
                title: 'Cycle Calculation',
            },

            {
                path: 'account',
                loadComponent: () =>
                    import(
                        './common/pages/account-management/account-management.component'
                    ).then((mod) => mod.AccountManagementComponent),
                title: 'Account',
            },
            {
                path: 'change-password',
                loadComponent: () =>
                    import(
                        './common/pages/change-password/change-password.component'
                    ).then((mod) => mod.ChangePasswordComponent),
                title: 'Change Password',
            },
        ],
    },
];
